import { notification } from "antd";
import codeMessage from "./codeMessage";
import * as authService from "@/auth";

const errorHandler = (error, emptyResult = null, navigate) => {
  const { response } = error;
  console.log("handlerError", error);
  if (!response) {
    // notification.config({
    //   duration: 20,
    // });
    // notification.error({
    //   message: "No internet connection",
    //   description: "Cannot connect to the server, Check your internet network",
    // });
    return {
      success: false,
      result: emptyResult,
      message: "Cannot connect to the server, Check your internet network",
    };
  } else if (response && response.status) {
    const message = response.data && response.data.message;
    const errorText = message || codeMessage[response.status];
    const { status } = response;
    notification.config({
      duration: 3,
    });
    notification.error({
      // message: `Request error ${status}`,
      description: errorText,
      key: errorText, //used to remove deuplicate messages
    });
    if (error.response.data.jwtExpired) {
      authService.logout();
      window.location.replace("/login");
    }
    return response.data;
  } else {
    notification.config({
      duration: 3,
    });
    notification.error({
      message: "Unknown Error",
      description: "An unknown error occurred in the app, please try again.",
      key: 'An unknown error occurred in the app, please try again.', //used to remove deuplicate messages
    });
    return {
      success: false,
      result: emptyResult,
      message: "An unknown error occurred in the app, please try again. ",
    };
  }
};

export default errorHandler;
